import {Service, signal} from '@angular/core'
import {delay, of, tap} from 'rxjs'
import {IProject} from '../general/types'

@Service()

export class ProjectService {

  public projects = signal<IProject[]>([])

  // Will get projects from the BE later
  public getProjects() {
    if (this.projects().length === 0) {
      // Get the projects from the BE
      return of(
        [
          {
            id: '1',
            ownerId: '2',
            ownerName: 'Landskrona kommun',
            consentName: 'Generellt bildsamtycke',
            projectName: 'Midsommar 2026',
            lastEdit: 1,
            newShare: false
          },
          {
            id: '2',
            ownerId: '3',
            ownerName: 'Landskrona stad',
            consentName: 'Modellsamtycke',
            projectName: 'Photoshoot med Frasse',
            lastEdit: 2,
            newShare: false
          },
          {
            id: '3',
            ownerId: '3',
            ownerName: 'Lomma kommun',
            consentName: 'Generellt bildsamtycke',
            projectName: 'Pildammarna på våren',
            lastEdit: 3,
            newShare: true
          },
          {
            id: '4',
            ownerId: '2',
            ownerName: 'Landskrona stad',
            consentName: 'Generellt bildsamtycke',
            projectName: 'Citadellet nyöppning',
            lastEdit: 8,
            newShare: false
          },
          {
            id: '5',
            ownerId: '5',
            ownerName: 'Moresco Foto AB',
            consentName: 'Generellt bildsamtycke',
            projectName: 'Citadellet nyöppning',
            lastEdit: 5,
            newShare: false
          }
        ]
      )
        .pipe(
          delay(1000),
          tap(projects => this.projects.set(projects)
          )
        )
    }
    return of(this.projects())
  }
}
